export type ImageUploadType = 'hero' | 'founder' | 'team' | 'clientLogo' | 'product' | 'gallery' | 'blog' | 'custom' | 'customIcon' | 'icon';

export interface ImageUploadConfig {
  type: ImageUploadType;
  label: string;
  width: number;
  height: number;
  aspectRatio: string;
  formats: string[];
  maxSizeMB: number;
  guidance: string;
}

export const IMAGE_UPLOAD_CONFIG: Record<ImageUploadType, ImageUploadConfig> = {
  hero: {
    type: 'hero',
    label: 'Hero Image',
    width: 1920,
    height: 1080,
    aspectRatio: '16:9',
    formats: ['JPG', 'PNG', 'WEBP'],
    maxSizeMB: 8,
    guidance: 'Best for large banner images. Landscape orientation recommended.',
  },
  blog: {
    type: 'blog',
    label: 'Featured Image',
    width: 1200,
    height: 630,
    aspectRatio: '1.91:1',
    formats: ['JPG', 'PNG', 'WEBP'],
    maxSizeMB: 5,
    guidance: 'Best for sharing on social media. Landscape orientation recommended.',
  },
  founder: {
    type: 'founder',
    label: 'Founder Image',
    width: 800,
    height: 800,
    aspectRatio: '1:1',
    formats: ['JPG', 'PNG', 'WEBP'],
    maxSizeMB: 5,
    guidance: 'Professional square portrait recommended.',
  },
  team: {
    type: 'team',
    label: 'Team Member Image',
    width: 800,
    height: 800,
    aspectRatio: '1:1',
    formats: ['JPG', 'PNG', 'WEBP'],
    maxSizeMB: 5,
    guidance: 'Square headshots work best.',
  },
  clientLogo: {
    type: 'clientLogo',
    label: 'Client Logo',
    width: 400,
    height: 200,
    aspectRatio: '2:1',
    formats: ['SVG', 'PNG'],
    maxSizeMB: 2,
    guidance: 'Transparent background recommended. SVG provides the best quality.',
  },
  product: {
    type: 'product',
    label: 'Product Image',
    width: 1200,
    height: 1200,
    aspectRatio: '1:1',
    formats: ['JPG', 'PNG', 'WEBP'],
    maxSizeMB: 5,
    guidance: 'Square product photography recommended.',
  },
  gallery: {
    type: 'gallery',
    label: 'Gallery Image',
    width: 1600,
    height: 900,
    aspectRatio: '16:9',
    formats: ['JPG', 'PNG', 'WEBP'],
    maxSizeMB: 5,
    guidance: 'Landscape images work best in gallery layouts.',
  },
  custom: {
    type: 'custom',
    label: 'Custom Section Image',
    width: 1200,
    height: 800,
    aspectRatio: '3:2',
    formats: ['JPG', 'PNG', 'WEBP'],
    maxSizeMB: 5,
    guidance: 'Recommended: 1200 × 800 px (3:2 landscape) high-quality photo.',
  },
  customIcon: {
    type: 'customIcon',
    label: 'Custom Icon',
    width: 64,
    height: 64,
    aspectRatio: '1:1',
    formats: ['SVG', 'PNG', 'WEBP', 'JPG'],
    maxSizeMB: 2,
    guidance: 'Recommended: 64 × 64 px (1:1 square) SVG or PNG with transparent background.',
  },
  icon: {
    type: 'icon',
    label: 'Custom Icon',
    width: 64,
    height: 64,
    aspectRatio: '1:1',
    formats: ['SVG', 'PNG', 'WEBP', 'JPG'],
    maxSizeMB: 2,
    guidance: 'Recommended: 64 × 64 px (1:1 square) SVG or PNG with transparent background.',
  },
};
